import type { ReactNode } from 'react';
import { Button } from '@mantine/core';

interface AddActionButtonProps {
  onClick: () => void;
  children: ReactNode;
  fullWidthOnMobile?: boolean;
}

export const AddActionButton = ({ onClick, children, fullWidthOnMobile }: AddActionButtonProps) => (
  <Button onClick={onClick} w={fullWidthOnMobile ? { base: '100%', sm: 'auto' } : undefined}>
    {children}
  </Button>
);
